<template>
	<div class="omapi-alert" :class="alertClass">
		<div class="alert-message">
			<slot />
			<core-verify-site-change v-if="$get('meta.verifySiteChange')" :site-data="meta" @changeType="changeType" />
		</div>
		<button v-if="canClose" type="button" class="unbutton close-alert" @click="startCloseAlert"></button>
	</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { alerts } from 'optinmonster-js-library/src/vue/campaigns/mixins/alerts';
export default {
	mixins: [alerts],
	props: {
		close: {
			type: Boolean,
			default() {
				return false;
			},
		},
		closes: {
			type: [String, Boolean],
			default() {
				return false;
			},
		},
		type: {
			type: String,
			default() {
				return '';
			},
		},
		meta: {
			type: Object,
			default() {
				return {};
			},
		},
		index: {
			type: Number,
			default: 0,
		},
		icon: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			closing: false,
			closed: false,
		};
	},
	computed: {
		canClose() {
			return this.close || this.closes;
		},
		alertClass() {
			let className = [];

			switch (this.type) {
				case 'error': {
					className.push('omapi-red omapi-action');
					break;
				}
				case 'info': {
					className.push('omapi-blue omapi-info');
					break;
				}
				case 'success': {
					className.push('omapi-green omapi-success');
					break;
				}
				case 'warn': {
					className.push('omapi-orange omapi-warning');
					break;
				}
			}

			if (this.canClose) {
				className.push('can-close');
			}

			if ('none' === this.icon) {
				className.push('no-icon');
			}

			if (this.closed) {
				className.push('omapi-alert-closed');
			}

			return className.join(' ');
		},
	},
	methods: {
		...mapMutations(['closeAlert']),
		...mapActions(['updateAlert']),
		startCloseAlert() {
			if (!this.closing) {
				// Check if we need to set a cookie so this alert won't open again.
				if (this.closes && true !== this.closes) {
					this.addClosedAlert(this.closes);
				}

				this.closing = true;
				this.closeAlert(this.index);
			}

			this.closed = true;
			setTimeout(() => {
				this.closing = false;
			}, 0);
		},
		changeType(type) {
			this.updateAlert([this.index, { type }]);
		},
	},
};
</script>
<style lange="scsss" scoped>
.close-alert * {
	cursor: pointer;
}
.omapi-alert.omapi-alert-closed {
	display: none;
}
</style>
